module.exports = __webpack_public_path__ + "img/stock3.0f4217bd.png";